import { render, staticRenderFns } from "./ThemeColorConfig.vue?vue&type=template&id=ca1d83ba&scoped=true"
import script from "./ThemeColorConfig.vue?vue&type=script&lang=js"
export * from "./ThemeColorConfig.vue?vue&type=script&lang=js"
import style0 from "./ThemeColorConfig.vue?vue&type=style&index=0&id=ca1d83ba&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca1d83ba",
  null
  
)

export default component.exports